import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { uniqPrimativeMerge } from '../../utils/arrayUtils';
import {
  IBlobStorageConfig,
  IConfigApiResponse,
  IDealerPortalFreeShippingConfig,
  ILogisticsConfig,
  ISalesConfig
} from './configInterfaces';
import { fetchConfigThunk, updateDpFreeShippingConfigThunk, updateLogisticsConfigThunk } from './thunks';

interface IConfigState {
  blobStorage?: IBlobStorageConfig;
  dpFreeShipping?: IDealerPortalFreeShippingConfig;
  loading: (keyof IConfigApiResponse)[];
  logistics?: ILogisticsConfig;
  sales?: ISalesConfig;
}

const initialState: IConfigState = {
  loading: []
};

const process = (state: IConfigState, action: PayloadAction<IConfigApiResponse | undefined>) => {
  if (action.payload) {
    const configKeys = Object.keys(action.payload);

    state.blobStorage = action.payload.blobStorage ?? state.blobStorage;
    state.dpFreeShipping = action.payload.dpFreeShipping ?? state.dpFreeShipping;
    state.loading = state.loading.filter(x => !configKeys.includes(x));
    state.logistics = action.payload.logistics ?? state.logistics;
    state.sales = action.payload.sales ?? state.sales;
  }
};

// tslint:disable: no-empty
// tslint:disable: object-literal-sort-keys
const configSlice = createSlice({
  initialState,
  name: 'config',
  reducers: {
    set: process
  },
  extraReducers: builder => {
    builder
      .addCase(fetchConfigThunk.pending, (state, action) => {
        state.loading = uniqPrimativeMerge(state.loading, action.meta.arg);
      })
      .addCase(fetchConfigThunk.fulfilled, process)
      .addCase(updateLogisticsConfigThunk.fulfilled, process)
      .addCase(updateDpFreeShippingConfigThunk.fulfilled, (state, action) => {
        if (action.payload) {
          state.dpFreeShipping = action.payload;
        }
      });
  }
});

export const { actions: configActionCreators, reducer: configReducer } = configSlice;
